module.exports = __webpack_public_path__ + "img/d2ff529c2c737180507f5c132b4f21c0.png";